<template>
	<div>
		<el-empty v-if="dataList.length==0" description="暂无数据"></el-empty>
		<b-row>
			<b-col sm="6" v-for="(item,index) in dataList" :key="index">
				<div style="margin-bottom: 20px;">
					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<span>{{item.platformTitle}}</span>
							<el-button @click="look(item)" style="float: right; padding: 3px 0"
								type="text">查看证书</el-button>
						</div>
						<div style="color: darkgray;" class="text item">
							证书发放日期：{{item.createTime }}
						</div>
						<div style="margin-top: 10px;color: darkgray;" class="text item">
							课程学习日期：{{item.beginTime }}至{{item.endTime }}
						</div>
					</el-card>
				</div>
			</b-col>
		</b-row>
		<div v-if="total>0" class="row">
			<div class="col-lg-12  wow fadeInUp">
				<div style="text-align: center;">
					<el-pagination background @current-change="getList" :current-page.sync="queryParams.pageNum"
						:page-size="queryParams.pageSize" layout="total, prev, pager, next" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="证书" :visible.sync="showBook" width="880px">
			<div v-if="showBook" ref="box" style="background-color: #fff;">
				<canvas id="canvas_warp" :width="c_width" :height="c_height"></canvas>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showBook = false">取 消</el-button>
				<el-button type="primary" @click="exportCanvasAsPNG">下载证书</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		certList
	} from "@/api/userCenter";
	export default {
		data() {
			return {
				activeName: 'first',
				queryParams: {
					pageNum: 1,
					pageSize: 10
				},
				showBook: false,
				total: 0,
				dataList: [],
				c_width: 936,
				c_height: 1327,
				zsData: {
					beginTime: '2023-03-23',
					endTime: '2023-05-23',
					platformTitle: '继续教育课程',
					code: 'fdfdf767263726372',
					nickName: '张三',
					userName: '370829199901235677',
					sex: '男',
					createTime: '2023-06-23',
					avatar: '',
					certTemplate: ''
				},
			}
		},
		mounted() {
			this.getList()
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize)
		},
		methods: {
			look(item) {
				this.zsData = item
				if (this.showBook) {
					setTimeout(() => {
						this.creatDarw();
					}, 500)
				} else {
					this.showBook = true
					window.addEventListener('resize', this.handleResize)
					this.$nextTick(() => { //使用nextTick为了保证dom元素都已经渲染完毕
						this.c_width = this.$refs.box.offsetWidth;
						this.c_height = this.c_width * (4 / 3)
					})
					setTimeout(() => {
						this.creatDarw();
					}, 500)
				}
			},
			handleResize() {
				this.c_width = this.$refs.box.offsetWidth;
				this.c_height = this.c_width * (4 / 3)
				setTimeout(() => {
					this.creatDarw();
				}, 500)
			},
			getList() {
				certList(this.queryParams).then(res => {
					this.dataList = res.data.rows
					this.total = res.data.total;
				})
			},
			exportCanvasAsPNG: function(id = 'canvas_warp', fileName = '证书') {
				var canvasElement = document.getElementById("canvas_warp");
				var MIME_TYPE = "image/png";
				var imgURL = canvasElement.toDataURL(MIME_TYPE);
				var dlLink = document.createElement('a');
				dlLink.download = fileName;
				dlLink.href = imgURL;
				dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');
				document.body.appendChild(dlLink);
				dlLink.click();
				document.body.removeChild(dlLink);
			},
			creatDarw() { //创建画板
				let that = this;
				let c1 = document.getElementById("canvas_warp");
				let ctx = c1.getContext('2d')
				var img = new Image();
				var txt_x = that.c_width;
				var txt_y = that.c_height;
				img.src = this.zsData.certTemplate
				//设置图片跨域访问
				img.setAttribute('crossOrigin', 'anonymous');
				img.onload = function() {
					ctx.drawImage(img, 0, 0, that.c_width, that.c_height)
					ctx.font = txt_x < 600 ? "bold 18px 微软雅黑" : "44px 微软雅黑";
					ctx.fillStyle = "#020202";
					if (txt_x < 600) {
						ctx.fillText("江苏省政府采购培训结业证书", txt_x - txt_x / 2 - 115, 100);
					} else {
						ctx.fillText("江苏省政府采购培训结业证书", txt_x - txt_x / 2 - 280, 260);
					}
					that.drawImgTx(ctx);
				}
			},
			drawImgTx(ctx) { // 绘制头像
				let that = this;
				let img = new Image();
				img.src = this.zsData.avatar
				img.setAttribute('crossOrigin', 'anonymous');
				img.onload = function() {
					let imgW = 0;
					let y = 0;
					if (that.c_width < 600) {
						imgW = 50;
						y = 140;
					} else {
						imgW = 110;
						y = 350;
					}
					let x = (that.c_width - imgW) / 2;

					let radius = imgW / 2;
					ctx.save();
					ctx.arc(x + radius, y, radius, 0, 2 * Math.PI);
					ctx.stroke()
					ctx.clip();
					ctx.drawImage(img, x, y - radius, imgW, imgW);
					ctx.closePath(); //闭合绘制的路径
					ctx.restore();
					let zsData = that.zsData;
					let z_txt =
						`该同志于${zsData.beginTime}至${zsData.endTime}参加${zsData.platformTitle}学习期满，准予结业，特此证明。有效期三年。`;
					let z_width = that.c_width - 100;
					let z_x = (that.c_width - z_width) / 2;
					if (that.c_width < 600) {
						z_width = that.c_width - 80;
						z_x = (that.c_width - z_width) / 2;
						that.drawText(ctx, z_txt, z_x, 165, z_width);
						ctx.font = "12px 微软雅黑";
						ctx.fillStyle = "#020202";
						ctx.fillText("培训证书号：", 70, 280);
						ctx.fillText(zsData.code, 140, 280);
						ctx.fillText("姓名：", 70, 300);
						ctx.fillText(zsData.nickName, 110, 300);
						ctx.fillText("身份证号：", 70, 320);
						ctx.fillText(zsData.userName, 130, 320);
						ctx.fillText("性别：", 70, 340);
						ctx.fillText(zsData.sex, 110, 340);
					} else {
						z_width = that.c_width - 300;
						z_x = (that.c_width - z_width) / 2;
						that.drawText(ctx, z_txt, z_x, 400, z_width);
						ctx.font = "21px 微软雅黑";
						ctx.fillStyle = "#020202";
						ctx.fillText("培训证书号：", 150, 620);
						ctx.fillText(zsData.code, 280, 620);
						ctx.fillText("姓名：", 150, 660);
						ctx.fillText(zsData.nickName, 220, 660);
						ctx.fillText("身份证号：", 150, 700);
						ctx.fillText(zsData.userName, 260, 700);
						ctx.fillText("性别：", 150, 740);
						ctx.fillText(zsData.sex, 220, 740);
					}
					let time_txt = '________年____月_____日';

					let dateList = zsData.endTime.split('-')

					if (that.c_width < 600) {
						ctx.fillText(time_txt, 180, 370);
						ctx.fillText(dateList[0], 185, 370);
						ctx.fillText(dateList[1], 235, 370);
						ctx.fillText(dateList[2], 270, 370);
					} else {
						ctx.fillText(time_txt, 470, 850);
						ctx.fillText(dateList[0], 480, 850);
						ctx.fillText(dateList[1], 570, 850);
						ctx.fillText(dateList[2], 630, 850);
					}
					that.drawImgZhang(ctx);
					that.drawImgZhang2(ctx);					
				}
			},
			// 盖章
			drawImgZhang(ctx) {
				let that = this;
				let img = new Image();
				img.src = require("../../assets/images/zhang_1.png")
				img.onload = function() {
					let imgW = 140;
					let x = 580;
					let y = 800;
					if (that.c_width < 600) {
						imgW = 50;
						x = 180;
						y = 370;
					} else {
						imgW = 140;
						x = 580;
						y = 830;
					}
					let radius = imgW / 2;
					ctx.save();
					ctx.beginPath()
					ctx.drawImage(img, x, y - radius, imgW, imgW);
					ctx.closePath(); //闭合绘制的路径
					let time_txt = '________年____月_____日';
					
					let dateList = that.zsData.createTime.split('-')
					
					if (that.c_width < 600) {
						ctx.fillText(time_txt, 180, 370);
						ctx.fillText(dateList[0], 185, 370);
						ctx.fillText(dateList[1], 235, 370);
						ctx.fillText(dateList[2], 270, 370);
					} else {
						ctx.fillText(time_txt, 470, 850);
						ctx.fillText(dateList[0], 480, 850);
						ctx.fillText(dateList[1], 570, 850);
						ctx.fillText(dateList[2], 630, 850);
					}
				}
			},
			// 盖章2
			drawImgZhang2(ctx) {
				let that = this;
				let img = new Image();
				img.src = require("../../assets/images/zhang_3.jpg")
				img.onload = function() {
					let imgW = 140;
					let x = 420;
					let y = 800;
					if (that.c_width < 600) {
						imgW = 50;
						x = 250;
						y = 370;
					} else {
						imgW = 140;
						x = 420;
						y = 830;
					}
					let radius = imgW / 2;
					ctx.save();
					ctx.beginPath()
					ctx.drawImage(img, x, y - radius, imgW, imgW);
					ctx.closePath(); //闭合绘制的路径
					let time_txt = '________年____月_____日';
					
					let dateList = that.zsData.createTime.split('-')
					
					if (that.c_width < 600) {
						ctx.fillText(time_txt, 180, 370);
						ctx.fillText(dateList[0], 185, 370);
						ctx.fillText(dateList[1], 235, 370);
						ctx.fillText(dateList[2], 270, 370);
					} else {
						ctx.fillText(time_txt, 470, 850);
						ctx.fillText(dateList[0], 480, 850);
						ctx.fillText(dateList[1], 570, 850);
						ctx.fillText(dateList[2], 630, 850);
					}
				}
			},
			drawText(ctx, t, x, y, w) {
				var chr = t.split("");
				var temp = "";
				var row = [];
				var count = 0;
				if (this.c_width < 600) {
					ctx.font = "14px 宋体";
				} else {
					ctx.font = "24px 宋体";
				}
				ctx.fillStyle = "#020202";
				for (var a = 0; a < chr.length; a++) {
					if (count == 0) {
						if (ctx.measureText(temp).width < w - 40) {
							;
						} else {
							count += 1;
							row.push(temp);
							temp = "";
						}
						temp += chr[a];
					} else {
						if (ctx.measureText(temp).width < w) {
							;
						} else {
							count += 1;
							row.push(temp);
							temp = "";
						}
						temp += chr[a];
					}
				}
				row.push(temp);
				if (this.c_width < 600) {
					for (var b = 0; b < row.length; b++) {
						ctx.fillText(row[b], b == 0 ? x + 30 : x, y + (b + 1) * 25);
					}
				} else {
					for (var b = 0; b < row.length; b++) {
						ctx.fillText(row[b], b == 0 ? x + 40 : x, y + (b + 1) * 50);
					}
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.zs_main {
		width: 100%;
		min-height: 600px;
		background-color: #ffffff;
	}

	.zs_warp {
		padding: 32px 35px;

		.zs_img {
			width: 100%;
			height: auto;
		}
	}

	.zs_warp {
		::v-deep .el-tabs__item.is-active {
			color: #f34343;
		}

		::v-deep .el-tabs__active-bar {
			height: 2px;
			background-color: #f34343;
		}

		::v-deep .el-tabs__item:hover {
			color: #f34343;
			cursor: pointer;
		}
	}

	.jl_warp {
		background-color: #ffffff;
		padding: 32px 35px;

		.list_warp {
			width: 100%;

			.jl_item {
				width: 100%;
				height: 198px;
				background-color: #f5f7fa;
				padding: 28px 45px;
				font-size: 16px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				border-radius: 10px;
				margin-bottom: 20px;


				p {
					text-align: left;
					color: #9199a1;
					margin-bottom: 10px;
				}
			}
		}
	}

	.zhengshu {
		align-items: center;
		flex-direction: row !important;
		justify-content: space-between !important;

		.left {
			flex: 1;
		}

		button {
			width: 138px;
			height: 48px;
			background-color: #f34343;
			font-size: 16px;
			color: #ffffff;
			height: 48px;
			border-radius: 48px;
		}
	}
</style>